export default "__VITE_ASSET__DsF4rc_1__"